module.exports = __webpack_public_path__ + "img/2BB.762c16bc.jpg";